import dayjs from "dayjs";
import { TFunction } from "next-i18next";

const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const arraySplit = (arr: Array<string>) => {
  const capitalizedArr = arr?.map(
    (str) => str.charAt(0).toUpperCase() + str.slice(1)
  );
  return capitalizedArr?.join(", ");
};

const formatTime = (t: number): string => {
  if (!t) return "-";

  let m: number = Math.floor(t / 60);
  let h: number = 0;

  if (m >= 60) {
    h = Math.floor(m / 60);
    m = m % 60;
  }

  const s: number = Math.floor(t % 60);

  return `${h}h ${m}m ${s}s`;
};

function formatSecondTimeToHHMMSS(seconds: number, t: TFunction): string {
  if(seconds === -1) return t("Unlimited");
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // 시, 분, 초를 두 자리 숫자로 포맷팅
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = remainingSeconds.toString().padStart(2, '0');
  // console.log("!@#!@#!@# seconds", seconds, formattedMinutes, formattedSeconds);
  if (hours > 0) {
    const formattedHours = hours.toString();
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  // } else if (minutes > 0) {
  //   return `${minutes.toString()}:${formattedSeconds}`;
  } else {
    return `${minutes.toString()}:${formattedSeconds}`;
    // return remainingSeconds + " sec";
  }
}

function formatSecondTimeToCredits(seconds: number) {
  if (seconds === -1) return `Unlimited Credits`;
  const min = seconds / 60;
  return `${Math.round(min * 100) / 100} Credits`;
}


const formatTimeDifference = (createdDate: Date): string => {
  const currentTime = new Date();
  const timeDifference =
    currentTime.getTime() - new Date(createdDate).getTime();
  const minutesDifference = Math.floor(timeDifference / (1000 * 60));
  const hoursDifference = Math.floor(minutesDifference / 60);

  if (minutesDifference < 1) {
    return "Just now";
  } else if (minutesDifference < 60) {
    return `${minutesDifference} ${
      minutesDifference === 1 ? "min" : "mins"
    } ago`;
  } else if (hoursDifference < 24) {
    return `${hoursDifference} ${hoursDifference === 1 ? "hour" : "hours"} ago`;
  } else if (hoursDifference < 24 * 7) {
    const days = Math.floor(hoursDifference / 24);
    return `${days} ${days === 1 ? "day" : "days"} ago`;
  } else {
    return dayjs(createdDate).format("YYYY-MM-DD");
  }
};

function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function convertToObject(data: { [key: string]: string }[]): { [key: string]: string } {
  let jsonObject: { [key: string]: string } = {};

  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    const key = Object.keys(item)[0];
    const value = item[key];
    jsonObject[key] = value;
  }

  return jsonObject;
}

function isValidEmail(email:string) {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;


  return emailPattern.test(email);
}

export { capitalize, arraySplit, formatTime, formatSecondTimeToHHMMSS, formatSecondTimeToCredits, formatTimeDifference, capitalizeFirstLetter, convertToObject, isValidEmail };



